<div class="mt-5">
    <div class="d-flex justify-content-center">
        <div class="card col-12 col-lg-5">
            <main class="form-signin">
                <form [formGroup]="registerForm" (ngSubmit)="register()" autocomplete="off">
                    <div class="text-center mb-4">
                        <h3 class="mb-3 font-weight-normal">
                            Sign up for free
                            <span class="text-danger">Today</span>
                        </h3>
                    </div>
                    <div class="form-floating mb-3">
                        <input formControlName="firstName" type="text" placeholder="First name" class="form-control"
                            [class.is-invalid]="submitted && registerForm.get('firstName')?.errors">
                        <label for="firstName">First name</label>
                        <span class="text-danger"
                            *ngIf="submitted && registerForm.get('firstName')?.hasError('required')">
                            First name is required
                        </span>
                        <span class="text-danger"
                            *ngIf="submitted && 
                            registerForm.get('firstName')?.hasError('minlength') || registerForm.get('firstName')?.hasError('maxlength')">
                            First name must be at least 3, and maximum 15 characters
                        </span>
                    </div>
                    <div class="form-floating mb-3">
                        <input formControlName="lastName" type="text" placeholder="Last name" class="form-control"
                            [class.is-invalid]="submitted && registerForm.get('lastName')?.errors">
                        <label for="lastName">Last name</label>
                        <span class="text-danger"
                            *ngIf="submitted && registerForm.get('lastName')?.hasError('required')">
                            Last name is required
                        </span>
                        <span class="text-danger"
                            *ngIf="submitted && 
                            registerForm.get('lastName')?.hasError('minlength') || registerForm.get('lastName')?.hasError('maxlength')">
                            Last name must be at least 3, and maximum 15 characters
                        </span>
                    </div>
                    <div class="form-floating mb-3">
                        <input formControlName="email" type="text" placeholder="Email" class="form-control"
                            [class.is-invalid]="submitted && registerForm.get('email')?.errors">
                        <label for="email">Email</label>
                        <span class="text-danger" *ngIf="submitted && registerForm.get('email')?.hasError('required')">
                            Email is required
                        </span>
                        <span class="text-danger" *ngIf="submitted && registerForm.get('email')?.hasError('pattern')">
                            Invalid email address
                        </span>
                    </div>

                    <div class="form-floating mb-3">
                        <input formControlName="password" type="password" placeholder="Password" class="form-control"
                            [class.is-invalid]="submitted && registerForm.get('password')?.errors">
                        <label for="password">Password</label>
                        <span class="text-danger"
                            *ngIf="submitted && registerForm.get('password')?.hasError('required')">
                            Password is required
                        </span>
                        <span class="text-danger"
                            *ngIf="submitted && 
                        registerForm.get('password')?.hasError('minlength') || registerForm.get('password')?.hasError('maxlength')">
                            Password must be at least 6, and maximum 15 characters
                        </span>
                    </div>

                    <div class="form-floatin" *ngIf="errorMessages.length > 0">
                        <identity-validation-messages [errorMessages]="errorMessages"></identity-validation-messages>
                    </div>

                    <div class="d-grid mt-4 px-1">
                        <button class="btn btn-lg btn-info" type="submit">Create Account</button>
                    </div>
                </form>

                <div class="row d-flex justify-content-center mt-3">
                    <div class="col-5">
                        <hr>
                    </div>
                    <div class="col-2 text-center">OR</div>
                    <div class="col-5">
                        <hr>
                    </div>
                </div>
                <div class="d-flex justify-content-between my-3">
                    <div #googleButton></div>
                    <button style="width: 180px;" class="btn btn-primary btn-sm" (click)="registerWithFacebook()">
                        Facebook
                    </button>
                </div>
                <p class="font-monospace fw-medium text-center text-muted mt-2 mb-0">
                    Already have an account? <a routerLink="/account/login" class="text-decoration-none">Login</a>
                </p>
            </main>
        </div>
    </div>
</div>